module.exports = __webpack_public_path__ + "img/Barakat-white.49d6b387.png";